module.exports = __webpack_public_path__ + "media/categories/2034-00def895.svg";